<div class="main-column">
	<div class="page-description">
		<h1 class="page-title" *ngIf="title">{{ title }}</h1>
		<app-page-intro-copy *ngIf="trustedDesc" [html]="trustedDesc"></app-page-intro-copy>
	</div>
	
	<div class="contributors-loading" *ngIf="authorsLoading && !authorsError">
		Loading...
	</div>
	
	<div class="contributors-loading" *ngIf="authorsError">
		<!-- <span>Sorry, something went wrong. Please <span class="retry-link" (click)="getAuthors()">try again</span>.</span> -->
	</div>
	
	<div class="contributors-list" *ngIf="!authorsLoading && !authorsError">
		<div class="contributors-ctnr" *ngFor="let contributor of authors">
			<div class="contributors-inner">
				<!-- <div class="summary-image">
					<picture *ngIf="contributor.thumbnail?.dynamic_url">
						<source [srcset]="contributor.thumbnail.dynamic_url + '?w=120&fm=webp'" type="image/webp">
						<source [srcset]="contributor.thumbnail.dynamic_url + '?w=120'" [type]="contributor.thumbnail.mime_type">
						<img [alt]="contributor.thumbnail.custom_properties.alt_text"
							[src]="contributor.thumbnail.dynamic_url + '?w=120'" class="book-image" loading="lazy">
					</picture>
				</div> -->
				<div class="summary-bio">
					<a class="author-name" routerLink="/news/author/{{ contributor.slug }}">
						<picture *ngIf="contributor.thumbnail?.dynamic_url">
							<source [srcset]="contributor.thumbnail.dynamic_url + '?w=200&fm=webp'" type="image/webp">
							<source [srcset]="contributor.thumbnail.dynamic_url + '?w=200'" type="image/jpeg">
							<img alt=""
								[src]="contributor.thumbnail.dynamic_url + '?w=200'" class="author-image" loading="lazy">
						</picture>
						{{ contributor.first_name }} {{ contributor.last_name }}
					</a>
					<!-- <div class="author-twitter">
						<span>
							<span>{{ contributor.social_username }}</span>
						</span>
					</div> -->
					<div class="author-desc">
						<span [innerHtml]="contributor.short_bio"></span>
						<a routerLink="/news/author/{{ contributor.slug }}">
							<span class="link">Everything from {{ contributor.first_name }}</span>
						</a>
					</div>
				</div>
			</div>
			<!-- <a class="button" routerLink="/author/{{ contributor.slug }}"></a> -->
		</div>
	</div>

	<app-best-offers *ngIf="environment.optionalFeatures.includes('best-offers')"></app-best-offers>
	<!-- <app-display-ad *ngIf="environment.googleAdsConfig || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad> -->
    <div *ngIf="trustedCopy" [innerHTML]="trustedCopy"></div>
</div>
<div class="sidebar">
	<!-- <app-how-we-make-money *ngIf="environment.optionalFeatures.includes('best-books')"></app-how-we-make-money> -->
	<app-display-ad type="articles-POS1" class="large-only" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS1'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
    <app-radar-link *ngIf="environment.siteTitle === 'Radar Sports'"></app-radar-link>
	<app-newsletter-signup-prompt *ngIf="environment.optionalFeatures.includes('newsletter')"></app-newsletter-signup-prompt>
	<app-latest-articles-list></app-latest-articles-list>
	<app-display-ad type="sidebar-short" *ngIf="environment.googleAdsConfig?.adSpaces?.['sidebar-short'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	<app-display-ad type="articles-POS2" class="large-only sticky" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS2'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	<!-- <app-upcoming-matches-list
        *ngIf="environment.availableSports.length > 0"></app-upcoming-matches-list> -->
	<!-- <app-futures-snapshot *ngIf="environment.availableSports.length > 0"></app-futures-snapshot> -->
	<app-odds-disclaimer *ngIf="environment.optionalFeatures.includes('odds-disclaimer')"></app-odds-disclaimer>
</div>